export type EthereumAddress = `0x${string}`;

export interface CurrencyData {
  name: string;
  chainId: number;
  address: EthereumAddress;
  decimals: number;
  logoURI: string;
  canBeUsedForDeposit?: boolean;
  canBeUsedForTransactionCurrency?: boolean;
  canBeUsedForReferredVolume?: boolean;
}

export const currenciesForPointRewards: CurrencyData[] = [
  {
    name: 'USDC',
    chainId: 1,
    address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    logoURI: '/assets/svg/usdc.svg',
    decimals: 18,
  },
  {
    name: 'ETH',
    chainId: 1,
    address: '0x0000000000000000000000000000000000000000',
    logoURI: '/assets/svg/ethereum.svg',
    decimals: 18,
  },
  {
    name: 'BTC',
    chainId: 0,
    address: '0x3333333333333333333333333333333333333333',
    logoURI: '/assets/svg/btc.svg',
    decimals: 8,
  },
  {
    name: 'POINT',
    chainId: 0,
    address: '0x0000000000000000000000000000000000000000',
    logoURI: '/assets/svg/coin.svg',
    decimals: 0,
  },
];

export const baseCurrencies: string[] = ['ETH', 'BTC', 'USD'];
